import React, { useEffect, useState, useRef } from 'react';
import './ChallengeHome.scss';
import ChallengeCarousel from '../challengeCarousel/ChallengeCarousel';
import { useDispatch, useSelector } from 'react-redux';
import { fetchChallengeList, fetchChallengeProfile } from '../../../actions/challengeListActions';
import { CHALLENGE, CHALLENGE_LIST } from '../../../common/challengeConstants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ChallengeNavButton, commonConstant } from '../../../common';
import { getDataFromSession, getParamsString } from '../../../utill.func';
import { homePageTabBtnSize } from '../../../common/commonConstant';
import {
  FETCH_CHALLENGES_DETAIL_SUCCESS,
  FETCH_CHALLENGES_PROFILE_SUCCESS,
  FETCH_BEGIN_CHALLENGES_DETAIL_SUCCESS,
  FETCH_BEGIN_CHALLENGES_PROFILE_SUCCESS,
} from '../../../actions/types';
import { fetchChallengeTeamDetail, fetchBeginChallengeTeamDetail } from '../../../actions';
import { isEmpty } from 'lodash';


const ChallengeHome = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [profileLoading, setProfileLoading] = useState(false);
  const [challengeStatus, setChallengeStatus] = useState(
    CHALLENGE_LIST.TYPES.ongoing,
  );
  
  const hasFetchedProfile = useRef(false);
  const hasFetchedBodyKeyTeamDetail = useRef(false);
  const hasFetchedBeginTeamDetail = useRef(false);

  const challengeList = useSelector(
    (state) => state.challengeListObj?.challengeList,
  );

  const challengeProfileList = useSelector(
    (state) => state.challengeListObj?.challengeProfile?.profileList
  );

  const { teamData } = useSelector(
    (state) => state.challengeTeamDashboard,
  );

  const beginChallengeProfileList = useSelector(
    (state) => state.challengeListObj?.beginChallengeProfile?.profileList
  );

  const { teamData: beginTeamData } = useSelector(
    (state) => state.beginChallengeTeamDashboard || {},
  );

  const { isAuthTokenSaved } = useSelector(
    (state) => state.tokenStatus,
  );

  const fetchChallenge = async (type) => {
    setIsLoading(true);
    await dispatch(fetchChallengeList(type ? { challengeStatus: type } : undefined))
      .finally(() => {
        setIsLoading(false);
      })
  };

  //TODO: need to implement when Self Challenge module available
  // const fetchChallengeSelfData = async () => {
  //   try {
  //     dispatch(fetchChallengeSelf());
  //   } catch (error) {
  //     throw new Error(error);
  //   }
  // }

  const fetchProfile = async (eventIdList) => {
    const { partyId, amwayNumber } = getDataFromSession('customer');
    const payloadObj = {
      partyId,
      aboId: amwayNumber,
      eventIds: eventIdList
    }
    setProfileLoading(true);
    await dispatch(fetchChallengeProfile(`?${getParamsString(payloadObj)}`))
    setProfileLoading(false);
  }

  const challengeTabList = CHALLENGE_LIST.HOME_TABS_MAPPING.map((tabObj) => {
    const name = tabObj.name;
    return challengeList && challengeList[name] && challengeList[name].length > 0 ? tabObj.label : null;
  }).filter(Boolean);

  const handleTabButtonChange = (index, value) => {
    const challengeVal = CHALLENGE_LIST.TYPE_MAP[value];
    if (!challengeList?.[challengeVal]) {
      fetchChallenge(challengeVal);
    }
    setChallengeStatus(challengeVal);
  };

  const handleCardClick = async (cardObj, isRegistered, challengeType) => {
    const { id, eventId, challengeStatus: type, completeDate, teamDashboardImage } = cardObj;
    const { partyId } = getDataFromSession('customer');
    // TODO: need to store in localstorage for camera screen's navigate back
    await dispatch({
      type: FETCH_CHALLENGES_DETAIL_SUCCESS,
      payload: cardObj,
    });
    const existingChallengeData = getDataFromSession('challengeData') || {};

    const updatedChallengeData = {
      ...existingChallengeData,
      challengeId: eventId,
      challengeEventId: id,
      challengeRewardDate: completeDate,
      myDashboardBg: teamDashboardImage,
      eventType: challengeType?.toLowerCase()
    }
    sessionStorage.setItem("challengeData", JSON.stringify(updatedChallengeData));
    let paramsObj = {};
    if (type === CHALLENGE_LIST.TYPES.upcoming || (type === CHALLENGE_LIST.TYPES.ongoing && !isRegistered)) {
      paramsObj = {
        challengeId: id,
        isRegistered
      }
      history.push(`${commonConstant.pathChallengeDetail}?${getParamsString(paramsObj)}`);
    }
    else if (type === CHALLENGE_LIST.TYPES.ongoing && isRegistered) {
      paramsObj = {
        challengeId: eventId,
        eventId: id,
        partyId
      }
      let routePath = commonConstant.pathChallengeTeamDashboard;
      if (challengeType?.toUpperCase() === CHALLENGE.type.ME) {
        routePath = commonConstant.pathChallengeMyDashboard;
      }
      history.push(`${routePath}?${getParamsString(paramsObj)}`);
    }
  }

  const handleBeginChallengeClick = async (cardObj, isRegistered, challengeType) => {
    const { id, eventId, challengeStatus: type, completeDate, teamDashboardImage, eventType } = cardObj;
    const { partyId } = getDataFromSession('customer');

    await dispatch({
      type: FETCH_BEGIN_CHALLENGES_DETAIL_SUCCESS,
      payload: cardObj,
    });

    const existingChallengeData = getDataFromSession('beginChallengeData') || {};

    const updatedChallengeData = {
      ...existingChallengeData,
      challengeId: eventId,
      challengeEventId: id,
      challengeRewardDate: completeDate,
      teamDashboardImg: teamDashboardImage,
      eventType: challengeType?.toLowerCase()
    }
    sessionStorage.setItem("beginChallengeData", JSON.stringify(updatedChallengeData));
   

    let paramsObj = null;
    let routePath = null
    if (type === CHALLENGE_LIST.TYPES.ongoing) {
      //if challenge is ongoing and user is not registered redirect to detail screen else to dashboard
      paramsObj = {
        challengeId: eventId,
        eventId: id,
        partyId,
        isRegistered
      }
      if(!isRegistered){ 
        routePath = commonConstant.pathBeginChallengeDetail;
      }else{
        routePath = commonConstant.pathBeginChallengeTeamDashBoard;
      }
      history.push(`${routePath}?${getParamsString(paramsObj)}`);
    }else if(type === CHALLENGE_LIST.TYPES.upcoming){
      paramsObj = {
        challengeId: id,
        isRegistered
      }
      routePath = commonConstant.pathBeginChallengeDetail;
      history.push(`${routePath}?${getParamsString(paramsObj)}`);
    }
  };

  useEffect(() => {
    if (isAuthTokenSaved) {
      const { TYPES } = CHALLENGE_LIST;
      const { ongoing, upcoming } = challengeList;

      if (!ongoing && !upcoming) {
        fetchChallenge();
      } else {
        if (!ongoing) {
          fetchChallenge(TYPES.ongoing);
        } else if (!upcoming) {
          fetchChallenge(TYPES.upcoming);
        }
      }
      if (ongoing?.length > 0) {
        setChallengeStatus(TYPES.ongoing);
      } else if (upcoming?.length > 0 && !ongoing.length > 0) {
        setChallengeStatus(TYPES.upcoming);
      }

      if (ongoing?.length > 0 && (!challengeProfileList || !beginChallengeProfileList) && !hasFetchedProfile.current) {
        hasFetchedProfile.current = true;
        const eventIdList = ongoing
          .filter((challenge) => challenge.eventId)
          .map((challenge) => challenge.eventId)
          .join(',');
        fetchProfile(eventIdList);
      }
    }
  }, [challengeList, isAuthTokenSaved]);


  useEffect(() => {
    if (challengeProfileList?.length && isEmpty(teamData) && challengeList?.[challengeStatus] && !hasFetchedBodyKeyTeamDetail.current) {
      hasFetchedBodyKeyTeamDetail.current = true;
      const { partyId, amwayNumber } = getDataFromSession('customer');
      dispatch(fetchChallengeTeamDetail({
        amwayNumber: amwayNumber,
        partyId,
        challengeId: challengeProfileList[0].id,
      }, challengeList?.[challengeStatus]));
    }
 
    if (beginChallengeProfileList?.length && isEmpty(beginTeamData) && !hasFetchedBeginTeamDetail.current) {
      hasFetchedBeginTeamDetail.current = true;
      const { partyId, amwayNumber } = getDataFromSession('customer');
      dispatch(fetchBeginChallengeTeamDetail({
        amwayNumber,
        partyId,
        challengeId: beginChallengeProfileList[0].id,
      }, challengeList?.[challengeStatus]));
    }
  }, [challengeProfileList, challengeList, beginChallengeProfileList, beginTeamData])

  useEffect(() => {
    if (teamData?.challengeType && challengeProfileList?.length
      && (challengeProfileList[0]?.challengeType?.toLowerCase() !== teamData?.challengeType?.toLowerCase()
        || !challengeProfileList[0]?.tagStatus)) {
      setProfileLoading(true);
      const updatedChallengeList = JSON.parse(JSON.stringify(challengeProfileList));
      updatedChallengeList[0] = {
        ...updatedChallengeList[0],
        tagStatus: teamData.teamDashboardStatus,
        challengeType: teamData.challengeType.toLowerCase(),
        maxTeamSize: teamData.teamFullSize
      };

      dispatch({
        type: FETCH_CHALLENGES_PROFILE_SUCCESS,
        payload: updatedChallengeList
      });
      setProfileLoading(false);
    }
  }, [teamData, challengeProfileList])

  useEffect(() => {
    if (beginTeamData?.challengeType && beginChallengeProfileList?.length
      && (beginChallengeProfileList[0]?.challengeType?.toLowerCase() !== beginTeamData?.challengeType?.toLowerCase()
        || !beginChallengeProfileList[0]?.tagStatus)) {
      const updatedBeginChallengeList = JSON.parse(JSON.stringify(beginChallengeProfileList));
      updatedBeginChallengeList[0] = {
        ...updatedBeginChallengeList[0],
        tagStatus: beginTeamData.teamDashboardStatus,
        challengeType: beginTeamData.challengeType.toLowerCase(),
        maxTeamSize: beginTeamData.teamFullSize
      };

      dispatch({
        type: FETCH_BEGIN_CHALLENGES_PROFILE_SUCCESS,
        payload: updatedBeginChallengeList
      })
    }
  }, [beginTeamData, beginChallengeProfileList])

  //TODO: need to implement when Self Challenge module available
  // useEffect(() => {
  //   if (isAuthTokenSaved && isAccessTokenFetched) {
  //     fetchChallengeSelfData();
  //   }
  // }, [isAuthTokenSaved, isAccessTokenFetched]);


  return (
    <>
      <div className="challenge-list">
        <ChallengeNavButton
          tabList={challengeTabList}
          onTabButtonChange={handleTabButtonChange}
          styleObj={{ fontSize: homePageTabBtnSize }}
          tabListClass='challenge-tab-list-home'
        />
        <div>
          <ChallengeCarousel
            carouselList={challengeList?.[challengeStatus]}
            isLoading={isLoading}
            isProfileLoading={profileLoading}
            challengeProfileList={challengeProfileList}
            beginChallengeProfileList={beginChallengeProfileList}
            onCardClick={handleCardClick}
            onBeginChallengeClick={handleBeginChallengeClick}
            showTag
          />
        </div>
        {/* <div className="challenge-self-carousel-container">
          <ChallengeSelfCarousel carouselSelfList={challengeSelfList} />
        </div> */}
      </div>
    </>
  );
};

export default ChallengeHome;